import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Breadcrumbs, H5 } from '../../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Input, Media } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { PlusCircle, Edit, Trash2 } from 'react-feather';
import ArbitratorDataModal from './ArbitratorDataModal';
import DeleteConfirmationModal from '../../../Common/Modals/DeleteConfirmationModal';
import { confirmDelete, fetchTableData } from '../../../../Api/ApiMethods';

const Arbitrators = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [clearSelectedRows, setClearSelectedRows] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState('add');
    const [selectedArbitrator, setSelectedArbitrator] = useState(null);

    const arbitratorApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/Arbitrator';

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        setSearch(event.target.value);
        setPage(1);
    };

    useEffect(() => {
        fetchTableData({
            apiEndpoint: arbitratorApiUrl,
            page,
            pageSize,
            search,
            setDataCallback: setData,
            setTotalRowsCallback: setTotalRows,
        });
    }, [page, pageSize, search, arbitratorApiUrl]);

    const toggleDeleteModal = () => setDeleteModal(!deleteModal);

    const openAddModal = () => {
        setModalMode('add');
        setSelectedArbitrator(null);
        setModalOpen(true);
    };

    const openModifyModal = (arbitrator) => {
        setModalMode('modify');
        setSelectedArbitrator(arbitrator);
        setModalOpen(true);
    };

    const columns = [
        { name: 'Ad Soyad', selector: row => row.fullName, sortable: true },
        { name: 'E-posta', selector: row => row.email, sortable: true },
        {
            name: 'Eylemler',
            cell: (row) => (
                <div
                    className="btn btn-outline-warning d-flex align-items-center justify-content-center"
                    onClick={() => openModifyModal(row)}
                >
                    <Edit size={18} />
                </div>
            ),
            ignoreRowClick: true,
            right: true,
            button: true
        },
    ];

    return (
        <>
            <Breadcrumbs parent='Kişi Tanımları' title='Hakemler' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Hakemler</H5>
                                <span>Tanımlanmış olan hakem bilgileri aşağıda listelenmektedir.</span>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex justify-content-end align-items-center w-100 file-content flex-wrap">
                                    <div className='form-inline me-2 mt-3 p-0 custom-responsive-width'>
                                        <div className='mb-0 form-group d-flex align-items-center border rounded px-2' style={{ height: '35px' }}>
                                            <i className='fa fa-search text-muted'></i>
                                            <Input
                                                type="text"
                                                placeholder="Ara.."
                                                value={search}
                                                onChange={(e) => handleSearch(e)}
                                                className="border-0 ms-2 shadow-none"
                                                style={{ height: '33px', flexGrow: 1 }}
                                            />
                                        </div>
                                    </div>
                                    <Media body className='text-end mt-3'>
                                        <div className="btn btn-outline-primary ms-2" onClick={openAddModal} style={{ height: '35px', display: 'inline-flex', alignItems: 'center' }}>
                                            <PlusCircle size={18} className="me-1"/>
                                            {' Hakem Ekle'}
                                        </div>
                                    </Media>
                                    {(selectedRows.length !== 0) &&
                                        <div className='btn btn-outline-danger ms-2 mt-3' onClick={toggleDeleteModal} style={{ height: '35px', display: 'inline-flex', alignItems: 'center' }}>
                                            <Trash2 size={18} className="me-1"/>
                                            {' Seçilenleri Sil'}
                                        </div>
                                    }
                                </div>

                                <div style={{ height: "40px" }}></div>

                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        onSelectedRowsChange={handleRowSelected}
                                        pagination
                                        paginationServer
                                        selectableRows
                                        clearSelectedRows={clearSelectedRows}
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setPage(page)}
                                        onChangeRowsPerPage={pageSize => { setPage(1); setPageSize(pageSize); }}
                                        striped
                                        noDataComponent={<div className="p-4 text-center">Hakem bulunamadı.</div>}
                                        progressPending={!data}
                                        progressComponent={<p>Yükleniyor...</p>}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ArbitratorDataModal
                apiEndpoint={arbitratorApiUrl}
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                mode={modalMode}
                selectedArbitrator={selectedArbitrator}
                refreshData={() =>
                    fetchTableData({
                        apiEndpoint: arbitratorApiUrl,
                        page,
                        pageSize,
                        search,
                        setDataCallback: setData,
                        setTotalRowsCallback: setTotalRows,
                    })
                }
            />
            <DeleteConfirmationModal
                isOpen={deleteModal}
                toggle={toggleDeleteModal}
                itemsToDelete={selectedRows}
                displayKey="fullName"
                onConfirm={() =>
                    confirmDelete({
                        apiEndpoint: arbitratorApiUrl,
                        selectedItems: selectedRows,
                        toggleModalCallback: toggleDeleteModal,
                        clearSelectionCallback: () => {
                            setSelectedRows([]);
                            setClearSelectedRows(!clearSelectedRows);
                        },
                        refreshDataCallback: () =>
                            fetchTableData({
                                apiEndpoint: arbitratorApiUrl,
                                page,
                                pageSize,
                                search,
                                setDataCallback: setData,
                                setTotalRowsCallback: setTotalRows,
                            }),
                    })
                }
            />
        </>
    );
};

export default Arbitrators;
